function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".envelope_svg__st4{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.envelope_svg__st15{fill:none;stroke:#7b66f6}.envelope_svg__st26{fill-rule:evenodd;clip-rule:evenodd;fill:#fefefe}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Fill-1",
  d: "M101.9 88l-91.1 9.6L5.1 44 42.6 8.4c2.6-2.5 6.6-2.9 9.6-1l44 27 5.7 53.6z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#e8ebf6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-3",
  d: "M101.9 88l-91.1 9.6L5.1 44 42.6 8.4c2.6-2.5 6.6-2.9 9.6-1l44 27 5.7 53.6z",
  fill: "#fff",
  stroke: "#7b66f6",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-5",
  d: "M5.1 44l91.1-9.6",
  fill: "none",
  stroke: "#7b66f6",
  strokeWidth: 0.75
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 9.7,
  y: 14,
  width: 84.4,
  height: 69.3
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 9.7,
  y: 14,
  width: 84.4,
  height: 69.3,
  id: "envelope_svg__mask-5_1_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_1_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Fill-7",
  mask: "url(#envelope_svg__mask-5_1_)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fefefe",
  d: "M16.1 83.3L94 75.1 87.6 14 9.7 22.2z"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_1_",
  filterUnits: "userSpaceOnUse",
  x: 8.6,
  y: 12.9,
  width: 86.6,
  height: 71.5
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref9 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 8.6,
  y: 12.9,
  width: 86.6,
  height: 71.5,
  id: "envelope_svg__mask-5_2_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_1_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_2_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-9",
  mask: "url(#envelope_svg__mask-5_2_)",
  fill: "#fff",
  stroke: "#7b66f6",
  strokeWidth: 2,
  d: "M16.1 83.3L94 75.1 87.6 14 9.7 22.2z"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_2_",
  filterUnits: "userSpaceOnUse",
  x: 19.3,
  y: 27.1,
  width: 20.3,
  height: 20.3
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref12 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 19.3,
  y: 27.1,
  width: 20.3,
  height: 20.3,
  id: "envelope_svg__mask-5_3_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_2_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_3_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Fill-10",
  d: "M19.4 38.4c-.6-5.6 3.5-10.6 9-11.2 5.6-.6 10.6 3.5 11.2 9 .6 5.6-3.5 10.6-9 11.2s-10.6-3.5-11.2-9",
  mask: "url(#envelope_svg__mask-5_3_)",
  fill: "none"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_3_",
  filterUnits: "userSpaceOnUse",
  x: 18.8,
  y: 26.6,
  width: 21.3,
  height: 21.3
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref15 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 18.8,
  y: 26.6,
  width: 21.3,
  height: 21.3,
  id: "envelope_svg__mask-5_4_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_3_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_4_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-11",
  d: "M19.4 38.4c-.6-5.6 3.5-10.6 9-11.2 5.6-.6 10.6 3.5 11.2 9 .6 5.6-3.5 10.6-9 11.2s-10.6-3.5-11.2-9z",
  mask: "url(#envelope_svg__mask-5_4_)",
  fill: "none",
  stroke: "#7b66f6"
});

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_4_",
  filterUnits: "userSpaceOnUse",
  x: 23.8,
  y: 33.6,
  width: 11.7,
  height: 8.9
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref18 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 23.8,
  y: 33.6,
  width: 11.7,
  height: 8.9,
  id: "envelope_svg__mask-5_5_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_4_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_5_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "envelope_svg__Group-14",
  mask: "url(#envelope_svg__mask-5_5_)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 27.034)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Fill-12",
  fill: "none",
  d: "M4.2 11l4.6 3.8 6.4-7.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-13",
  className: "envelope_svg__st15",
  d: "M4.2 11l4.6 3.8 6.4-7.9"
})));

var _ref20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_5_",
  filterUnits: "userSpaceOnUse",
  x: 5.1,
  y: 34.4,
  width: 96.8,
  height: 63.2
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref21 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 5.1,
  y: 34.4,
  width: 96.8,
  height: 63.2,
  id: "envelope_svg__mask-5_6_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_5_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_6_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Fill-15",
  mask: "url(#envelope_svg__mask-5_6_)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fff",
  d: "M101.9 88l-91.1 9.6L5.1 44l49.2 29.3 42-38.9z"
});

var _ref23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_6_",
  filterUnits: "userSpaceOnUse",
  x: 4.6,
  y: 34,
  width: 97.8,
  height: 64.1
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref24 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 4.6,
  y: 34,
  width: 97.8,
  height: 64.1,
  id: "envelope_svg__mask-5_7_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_6_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_7_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-16",
  mask: "url(#envelope_svg__mask-5_7_)",
  fill: "none",
  stroke: "#7b66f6",
  strokeLinejoin: "bevel",
  d: "M101.9 88l-91.1 9.6L5.1 44l49.2 29.3 42-38.9z"
});

var _ref26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_7_",
  filterUnits: "userSpaceOnUse",
  x: 10.8,
  y: 67,
  width: 91.1,
  height: 30.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref27 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 10.8,
  y: 67,
  width: 91.1,
  height: 30.6,
  id: "envelope_svg__mask-5_8_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_7_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_8_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref28 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Fill-17",
  d: "M101.9 88l-91.1 9.6 37.6-28.5c3.1-2.4 7.3-2.8 10.9-1.1l42.6 20z",
  mask: "url(#envelope_svg__mask-5_8_)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fff"
});

var _ref29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_8_",
  filterUnits: "userSpaceOnUse",
  x: 10.4,
  y: 66.5,
  width: 91.7,
  height: 31.6
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref30 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 10.4,
  y: 66.5,
  width: 91.7,
  height: 31.6,
  id: "envelope_svg__mask-5_9_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_8_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_9_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref31 = /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-18",
  d: "M101.9 88l-91.1 9.6 37.6-28.5c3.1-2.4 7.3-2.8 10.9-1.1l42.6 20z",
  mask: "url(#envelope_svg__mask-5_9_)",
  fill: "none",
  stroke: "#7b66f6",
  strokeLinejoin: "bevel"
});

var _ref32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_9_",
  filterUnits: "userSpaceOnUse",
  x: 43.4,
  y: 23.5,
  width: 37.4,
  height: 4.9
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref33 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 43.4,
  y: 23.5,
  width: 37.4,
  height: 4.9,
  id: "envelope_svg__mask-5_10_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_9_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_10_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  id: "envelope_svg__Group-21",
  mask: "url(#envelope_svg__mask-5_10_)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(40 22.034)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Fill-19",
  className: "envelope_svg__st26",
  d: "M3.5 5.9L40.8 2"
}), /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-20",
  className: "envelope_svg__st15",
  d: "M3.5 5.9L40.8 2"
})));

var _ref35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_10_",
  filterUnits: "userSpaceOnUse",
  x: 44.2,
  y: 30.6,
  width: 37.4,
  height: 4.9
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref36 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 44.2,
  y: 30.6,
  width: 37.4,
  height: 4.9,
  id: "envelope_svg__mask-5_11_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_10_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_11_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  id: "envelope_svg__Group-24",
  mask: "url(#envelope_svg__mask-5_11_)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(40 29.034)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Fill-22",
  className: "envelope_svg__st26",
  d: "M4.2 6l37.3-4"
}), /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-23",
  className: "envelope_svg__st15",
  d: "M4.2 6l37.3-4"
})));

var _ref38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "envelope_svg__Adobe_OpacityMaskFilter_11_",
  filterUnits: "userSpaceOnUse",
  x: 44.9,
  y: 38.7,
  width: 26,
  height: 3.7
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));

var _ref39 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 44.9,
  y: 38.7,
  width: 26,
  height: 3.7,
  id: "envelope_svg__mask-5_12_"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#envelope_svg__Adobe_OpacityMaskFilter_11_)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__path-4_12_",
  className: "envelope_svg__st4",
  d: "M9.9 98.7l93.1-9.8L93.7.4.6 10.2z"
})));

var _ref40 = /*#__PURE__*/React.createElement("g", {
  id: "envelope_svg__Group-27",
  mask: "url(#envelope_svg__mask-5_12_)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(40 36.034)"
}, /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Fill-25",
  className: "envelope_svg__st26",
  d: "M4.9 5.9l25.9-2.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "envelope_svg__Stroke-26",
  className: "envelope_svg__st15",
  d: "M4.9 5.9l25.9-2.7"
})));

function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "envelope_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 104 100",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 104 100"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40);
}

export default __webpack_public_path__ + "f2421dd544d39f38480a834261d71c30.svg";
export { SvgEnvelope as ReactComponent };